
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/ad-service-account-scanner",
      function () {
        return require("private-next-pages/tools/ad-service-account-scanner.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/ad-service-account-scanner"])
      });
    }
  